import moment from "moment";

export const calculateAgeFromYear = fullYear => {
  const year = Number.parseInt(moment().format("YY"), 10);
  const bornYear = Number(fullYear.substr(2, 3));

  if (bornYear > year) {
    return year - bornYear + 100;
  } else {
    return year - bornYear;
  };
};
